import { createSubscriptions } from '@wix/podcasts-common/dist/pubsub';

class Store<T> {
  private _subscriptions;
  private _state: T;

  constructor(initialState?: T) {
    this._subscriptions = createSubscriptions();
    this._state = initialState;
  }

  subscribe(fn: Function) {
    return this._subscriptions.subscribe(fn);
  }

  get(): T {
    return this._state;
  }

  // TODO: revert type when ts fixed http://tc.dev.wixpress.com/viewLog.html?buildId=69746852
  // set(newState: T | ((T) => T)) {
  set(newState) {
    this._state =
      typeof newState === 'function' ? newState(this._state) : newState;
    this._subscriptions.publish(this._state);
  }
}

export default Store;
